import { Directive, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import moment from 'moment';
import { DateInputEnum } from '../../../models/date-input.enum';

/**
 * Base Editor Custom AgGrid for Date/DateTime/Time Input.
 * It contains common functionalities used by DateCellEditorInlineComponent
 * and DateCellEditorPopupComponent
 */
@Directive()
export abstract class DateCellEditorBaseComponent {
    readonly inputType = input.required<DateInputEnum>();
    readonly timeInputFormat = input.required<string>();
    readonly dateInputFormat = input.required<string>();
    readonly dateFormControl = input.required<FormControl>();
    readonly cellReady = input.required<boolean>();

    onSpacebarClick(event: KeyboardEvent) {
        event.preventDefault();
        const formControl = this.dateFormControl();
        formControl.setValue(moment(Date.now()));
    }
    updateModel(value: moment.Moment | null) {
        const formControl = this.dateFormControl();
        formControl.setValue(value);
    }
    getValue(): moment.Moment | null {
        const formControl = this.dateFormControl();
        return formControl.getRawValue();
    }
}
